import * as Yup from "yup";

import type { CatCovered, CatEntryPage, CatQuote } from "@/api_client";
import { getErrorMessage } from "@/utils/errorMessage";
import { AgeValidator } from "@/validators/shared/ageValidators";
import { validSSN } from "@/validators/shared/ssnValidator";

export type CatEntryFormType = Pick<
  CatQuote,
  "productType" | "policyHolderSsn" | "catCovered"
>;

const CatCoveredSchema = (
  content?: CatEntryPage | null,
): Yup.ObjectSchema<Pick<CatCovered, "catName" | "catBreed">> =>
  Yup.object({
    catName: Yup.string()
      .required(
        getErrorMessage(
          content?.catNameQuestion?.validationMessages?.value,
          "required",
        ),
      )
      .max(
        50,
        getErrorMessage(
          content?.catNameQuestion?.validationMessages?.value,
          "max",
        ),
      ),
    catBreed: Yup.string().required(
      getErrorMessage(
        content?.catBreedQuestion?.validationMessages?.value,
        "required",
      ),
    ),
  });

export const CatEntryValidationSchema = (
  content?: CatEntryPage | null,
): Yup.ObjectSchema<CatEntryFormType> =>
  Yup.object({
    productType: Yup.string().oneOf(["cat"]).required(),
    policyHolderSsn: Yup.string()
      .required(
        getErrorMessage(
          content?.policyHolderSsn?.validationMessages?.value,
          "required",
        ),
      )
      .test(
        "valid-ssn",
        getErrorMessage(
          content?.policyHolderSsn?.validationMessages?.value,
          "valid-ssn",
        ),
        validSSN,
      )
      .test(
        "is-18+",
        getErrorMessage(
          content?.policyHolderSsn?.validationMessages?.value,
          "is-18+",
        ),
        (ssn: string) => {
          const ageValidator = new AgeValidator(ssn);
          return ageValidator.isAtLeast18;
        },
      ),
    catCovered: CatCoveredSchema(content).required(),
  });
